import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Password } from "primereact/password";

export default function ChangePasswordForm({
  isOpen,
  onClose,
  onSubmit,
  initialData,
}) {
  const [formData, setFormData] = useState({
    userId: 0,
    currentId: 0,
    address: "",
    notes: "",
    gender: 0,
    fullName: "",
    email: "",
    mobilePhones: "",
    status: true,
    password: "",
    birthDate: new Date().toISOString(),
    recordDate: new Date().toISOString(),
    updateContactDate: new Date().toISOString(),
  });

  useEffect(() => {
    if (initialData) {
      setFormData(initialData);
    } else {
      setFormData({
        userId: 0,
        currentId: 0,
        address: "",
        notes: "",
        gender: 0,
        fullName: "",
        email: "",
        mobilePhones: "",
        status: true,
        password: "",
        birthDate: new Date().toISOString(),
        recordDate: new Date().toISOString(),
        updateContactDate: new Date().toISOString(),
      });
    }
  }, [initialData]);

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    if (!formData.password.trim()) {
      newErrors.password = "Boş bırakılamaz.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const generateRandomPassword = (length = 12) => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*";
    let result = "";
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
  };

  const handleGeneratePassword = (e) => {
    e.preventDefault();
    const newPassword = generateRandomPassword();
    setFormData({ ...formData, password: newPassword });
  };
  const handleChange = (name, value) => {
    setErrors({ ...errors, [name]: null });
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      onSubmit(formData); 
    }
  };
  const footer = () => {
    return (
      <div className=" flex  w-full m-0">
        <div className="p-d-flex p-jc-end col-12 ">
          <Button
            className="w-full "
            label="Güncelle"
            icon="pi pi-check"
            severity="success"
            outlined
            onClick={handleSubmit}
          />
        </div>
      </div>
    );
  };
  return (
    <Dialog
      className="max-w-full w-11 md:w-8  xl:w-6  "
      visible={isOpen}
      footer={footer()}
      onHide={onClose}
      header={initialData ? "Kullanıcı Görüntüle" : "Yeni Kullanıcı"}
    >
      <form className="  grid mt-3  ">
        <div className={`col-12 md:col-8  `}>
          <div className="p-inputgroup flex-1 w-12    ">
            <span className="p-inputgroup-addon w-7rem">Şifre</span>
            <Password
              id="userpassword"
              name="userpassword"
              feedback={false}
              value={formData.password}
              onChange={(e) => handleChange("password", e.target.value)}
              weakLabel="Kolay"
              mediumLabel="Orta"
              strongLabel="Zor"
              toggleMask
              promptLabel="Güçlü şifrenizi giriniz."
              inputStyle={{
                width: "100%",
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius:   0,
                borderTopRightRadius:  0,
              }}
              pt={{ iconField: { root: { className: "w-full" } } }}
            />
 <Button
          label="Üret"
          icon="pi pi-refresh"
          onClick={handleGeneratePassword}
          severity="info"
        />
            {errors.password && (
              <span className="p-inputgroup-addon max-w-max">
                <small className="p-error">{errors.password}</small>
              </span>
            )}
          </div>
        </div>
        <div
          className={`col-12 md:col-4 flex  align-items-center  `}
        >
          <div className="  flex-1 w-12 flex justify-content-center flex-wrap    ">
            <span>Yeni şifre giriniz</span>
          </div>
        </div>
      </form>
    </Dialog>
  );
}
